import axios from 'axios';


type StatisticsApiResponse = {
    total_count: number;
    genres: {
        id: number;
        genre: string;
        parent: string | null;
        count: number;
        children: {
            id: number;
            parent: string | null;
            genre: string;
            count: number;
        }[];
    }[];
};

type SpotListApiResponse = {
    spot_list: {
        id: number;
        name: string;
    }[];
};

type Statistics = {
    totalCount: number;
    genres: {
        id: number;
        genre: string;
        count: number;
        parent: string | null;
        children: {
            id: number;
            parent: string | null;
            genre: string;
            count: number;
        }[];
    }[],
};

type SpotList = {
    id: number;
    name: string;
}[];


export function useStatistics() {
    async function getStatistics(): Promise<Statistics> {
        try {
            const { data } = await axios.get<StatisticsApiResponse>(`${window.location.origin}/api/map/statistics`);
            const statistics: Statistics = {
                totalCount: data.total_count,
                genres: data.genres.map(({ id, genre, parent, count, children }) => {
                    return {
                        id,
                        genre,
                        count,
                        parent,
                        children,
                    };
                }),
            };
            return statistics;
        } catch (e) {
            return {
                totalCount: 0,
                genres: [],
            };
        };
    };

    async function getSpotList(genre: string): Promise<SpotList> {
        try {
            const { data: { spot_list: spotList } } = await axios.get<SpotListApiResponse>(`${window.location.origin}/api/map/statistics/${genre}`);
            return spotList;
        } catch (e) {
            return [];
        };
    };

    return { getStatistics, getSpotList };
};
